import { render, staticRenderFns } from "./ComunicacionesGrid.vue?vue&type=template&id=350cc4ea&"
import script from "./ComunicacionesGrid.vue?vue&type=script&lang=ts&"
export * from "./ComunicacionesGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports